import React from "react";
import { StoreProvider } from "./src/context/storeContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
);
